import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { BaseService } from '../../../core/service/base-service';
import { SolubilityModal } from '../modal/solubility-modal';

@Injectable({
  providedIn: 'root',
})
export class SolubilityServiceService extends BaseService<SolubilityModal> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }
  getModuleName(): string {
    return 'chemical/solubility';
  }

  validate(): boolean {
    return false;
  }
}
